module.exports = __webpack_public_path__ + "d308073b/img/pwrd-by-sourcery-black.bba9ba41.svg";